// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Pj-z","breadcrumbItem":"Qj-z","hideOnMobile":"Rj-z"};